
import Vue from 'vue'

export default Vue.extend({
  name: 'BottomHeaderMenuStatic',
  props: {
    formId: {
      type: Number,
      required: true,
      default: 0
    }
  }
})
